import type { ReadonlyDeep } from 'type-fest';

import { ExternalReferenceInput } from '@e-socna/data-layer';

import { pruneInput } from '../../../utils/prune-input.util';

export function externalReferenceForm2ApiMapper(
  externalReference: ReadonlyDeep<ExternalReferenceInput>,
): ReadonlyDeep<ExternalReferenceInput> {
  return pruneInput(externalReference, ExternalReferenceInput);
}
